import styled from 'styled-components'

import Price from '../../../pricing/Price'
import LineItemLabel from '../../../pricing/LineItemLabel'

const Table = styled.table`
  width: 100%;
  min-width: 216px;
  text-align: left;

  tfoot {
    font-weight: normal;
  }

  td {
    padding: 8px 0;
    &:last-child {
      text-align: right;
    }
  }
`

const CardPricingBreakdown = ({ pricing, pricingSuffix }) => (
  <Table className="qa-pricing-breakdown">
    <tbody>
      {pricing?.lineItems?.map((item, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <tr key={index}>
          <td>
            <LineItemLabel item={item} pricingSuffix={pricingSuffix} />
          </td>
          <td>
            <Price value={item.amount} />
          </td>
        </tr>
      ))}
      {pricing?.customerServiceFee > 0 && (
        <tr>
          <td>
            <span>Service Fee</span>
          </td>
          <td>
            <Price value={pricing?.customerServiceFee} />
          </td>
        </tr>
      )}
      {pricing?.taxAmount > 0 && (
        <tr>
          <td>
            <span>Tax</span>
          </td>
          <td>
            <Price value={pricing?.taxAmount} />
          </td>
        </tr>
      )}
    </tbody>
  </Table>
)

export default CardPricingBreakdown
